// extracted by mini-css-extract-plugin
export default {"solutions":"Solutions_solutions__vWGwz","titleRow":"Solutions_titleRow__uG4ou","textWrap":"Solutions_textWrap__N2DdJ"};